import { BasicDialogProperties } from "../../../../basic/view/dialogs/BasicDialogProperties";

export class Poker2StarterPackageBuyConfirmationDialogProperties extends BasicDialogProperties {
    public starterPackageId: number = NaN;

    constructor(starterPackageId: number) {
        super();

        this.starterPackageId = starterPackageId;
    }
}
